import { SET_BROADCASTS, SAVE_BROADCAST, DELETE_BROADCAST, RESET } from './actionTypes'

function initialState( preserve = {} ) {
  return Object.assign({},{
    broadcasts : {},
    broadcastsSorted : [],
  }, preserve )
}

export default function (state = initialState(), action) {

  console.log('Broadcasts - Reducer')

  switch (action.type) {

    case SET_BROADCASTS:
      state.broadcasts = action.broadcasts
      state.broadcastsSorted = sortBroadcasts ( { broadcasts : action.broadcasts } )
      break;

    case SAVE_BROADCAST:
      state.broadcasts[ action.broadcast.id] = action.broadcast
      state.broadcastsSorted = sortBroadcasts ( { broadcasts : state.broadcasts } )
      break;

    case DELETE_BROADCAST:
      delete state.broadcasts[ action.broadcastId ]
      state.broadcastsSorted = sortBroadcasts ( { broadcasts : state.broadcasts } )
      break;

    case RESET:
      state = initialState()
  }

  return state
}

function sortBroadcasts( options={} ) {

  var sortable=[]

  for (let [ id, broadcast ] of Object.entries( options.broadcasts ) ) {

      if (!(broadcast.date instanceof Date) ) {
        let t = broadcast.date.split(/[- :]/);
        broadcast.date = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]));
      }
      sortable.push( broadcast )
  }

  if ( sortable.length ) sortable.sort( (a,b) => (( a.date ) > ( b.date ) ? 1 : -1 ) )

  return sortable

}